/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import {
	transparentize
} from "polished";
import styled from "styled-components";

import {
	columnWrapper,
	ellipsis,
	rowWrapper
} from "../../styled/styled-extends";
import { 
	setFont,
	setPosition
} from "../../styled/styled-mixins";
import {
	typo
} from "../../styled/styled-variables";

// EXPORT

export const ErrorWrapper = styled.div`
	background-color: #F04124;
	border-radius: 8px;
	color: #FFF;
	padding: 16px;
`;

export const MessageListInnerWrapper = styled.div`
	align-items: center;
	align-self: normal;
	background-color: #FFF;
	border-right: 1px solid #C5C5C5;
	max-width: 320px; // ?
	width: 100%;
	min-height: 100vh;
	min-height: -webkit-fill-available;
	${setPosition(
		"fixed", 
		{
			"bottom": 0,
			"left": 0,
			"top": "56px",
			"z-index": 1
		}
	)}
	${columnWrapper}
`;

export const MessageListInnerFooterWrapper = styled.div`
`;




export const MessageListItem = styled.div`
	align-items: center;
	cursor: pointer;
	gap: 12px;
	padding: 16px;
	width: 100%;
	${rowWrapper}
`;

export const MessageListItemArrowWrapper = styled.div`
	background-color: #000; //...
	border-radius: 999px;
	height: 24px;
	width: 24px;
	${rowWrapper}
`;

export const MessageListItemContent = styled.div`
	flex: 1;
	${columnWrapper}

	> strong {
		color: #000;
		// ellipsis
	}
`;

export const MessageListItemUnreadWrapper = styled.div`
	background-color: red; //...
	border-radius: 999px;
	height: 8px;
	width: 8px;
	${rowWrapper}
`;




export const MessageListItemWrapper = styled.div`
	flex: 1;
	overflow-y: auto;
	width: 100%;
	${columnWrapper}

	> div {
		&:not(:first-child) {
			border-top: 1px solid #DDD;
		}
	}
`;

export const MessageListWrapper = styled.div`
	align-items: center;
	align-self: normal;
	//background-color: yellow;
	max-width: 320px; // ?
	width: 100%;
	${columnWrapper}
	
`;

export const MessageWrapper = styled.div`
	justify-content: center;
	padding: 16px;
	width: 100%;
	${rowWrapper}
`;

export const ProductCard = styled.div`
	margin-top: 24px;
	border: 1px solid transparent;
	border-radius: 8px;
	//gap: 16px;
	overflow: hidden;
	width: 100%;
	${columnWrapper}

	strong {
		color: #000;
	}

	.img {
		//border-radius: 50%;
		height: 64px;	    
		width: 64px;
	}

	.storeContent {
		text-align: left;
		${columnWrapper}

		p {
			padding-top: 0;
			${columnWrapper}
		}
	}

	${(props) => {
		const {
			card,
			typoColors
		} = props.theme;

		return `
			background-color: ${card.background};
			border-color: ${card.border};

			.storeContent {
				> strong {
					color: ${typoColors.level1};
					font-size: ${typo.fontSizes.default};
				}
			}
		`;
	}};
`;

export const ComponentWrapper = styled.div`
	justify-content: center;
	align-items: center;
	gap: 24px;
	padding: 16px;
	width: 100%;
	${columnWrapper}

	.productOverlay {
		align-items: center;
		height: 100%;
		justify-content: center;
		padding: 24px;
		width: 100%;
		${setPosition(
			"absolute", 
			{
				"left": 0,
				"top": 0,
				"z-index": 1
			}
		)}
		${columnWrapper}
	}

	.reservationCard {
	}

	.reservationCardBody {
	}

	.reservationCardFooter {
		gap: 16px;
		${rowWrapper}

		.button {
			flex: 1;
		}
	}

	.reservationCardHeader {
		background-color: #FFF;

		strong {
			color: #000;
		}
	}

	.storeOverlay {
		align-items: center;
		height: 48px;
		justify-content: center;
		width: 100%;
		${setPosition(
			"absolute", 
			{
				"left": 0,
				"top": "-24px",
				"z-index": 2
			}
		)}
		${columnWrapper}

		.img {
			border-radius: 50%;
			height: 48px;	    
			width: 48px;
		}
	}

	@media only screen and (min-width: 390px) {
	}

	@media only screen and (min-width: 576px) {
		padding: 24px;
	}

	@media only screen and (min-width: 768px) {
	}

	@media only screen and (min-width: 1024px) {
		padding: 32px;
	}

	@media only screen and (min-width: 1280px) {
		padding: 40px;
	}

	@media only screen and (min-width: 1440px) {
		padding: 48px;
	}

	${(props) => {
		const {
			backgroundColors,
			body,
			card,
			header,
			typoColors
		} = props.theme;

		let loaderWrapperOpacity = 0;
		let loaderWrapperPointerEvents = "none";

		if(props.loaderActive) {
			loaderWrapperOpacity = 1;
			loaderWrapperPointerEvents = "auto";
		}

		return `
			background-color: ${body.background};

			.productOverlay {
				background-color: ${transparentize(0.4, backgroundColors.level1)};
				color: ${typoColors.level8};

				span {
					font-weight: 600;
				}

				strong {
					color: ${typoColors.level9};
					font-size: ${typo.fontSizes.large};
				}

				> strong {
					letter-spacing: 3px;
					${setFont(
						typo.fontFamilies.heebo,
						typo.fontSizes.huge,
						500,
						typo.lineHeight.default,
						typoColors.level9
					)}
				}
			}
		`;
	}};
`;
